import React, { Component } from "react";
import PropTypes from "prop-types";
import InvalidFeedback from "../../../common/invalid_feedback";

class ProfileForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: props.name,
      profile: Object.assign({}, props.profile),
      related_links: Object.assign([], props.related_links),
      previewImage: {
        url: props.image
      },
      errors: {
        image: null,
        profile: {},
        related_links: [{}]
      },
      isSaving: false
    };
  }

  onPreviewImageChange = (event) => {
    const file = event.target.files[0];

    if (!file) return;
    if (/^image/.test(file.type)) {
      const reader = new FileReader();
      reader.onloadend = () => {
        this.setState({ previewImage: { url: reader.result }, image: file });
      };
      reader.readAsDataURL(file);
    }
  }

  onProfileChange = (event) => {
    const { profile } = this.state;
    const field = event.target.name;
    profile[field] = event.target.value;
    this.setState({profile: profile});
  };

  onRelatedLinksChange = (event) => {
    const { related_links } = this.state;
    const field = event.target.name;

    if (related_links.length > 0) {
      related_links[0][field] = event.target.value;
      if (!event.target.value) {
        related_links[0]._destroy = true;
      }
    } else {
      related_links.push({url: event.target.value});
    }
    this.setState({related_links: related_links});
  };

  handleFormSubmit = (event) => {
    event.preventDefault();
    this.setState({isSaving: true});

    const { actions, handleEditButtonClick } = this.props;
    actions.updateUser(this.state).then(() => {
      this.setState({isSaving: false});
      handleEditButtonClick();
    }).catch(errors => {
      this.setState({errors: errors, isSaving: false});
    });
  }

  render () {
    const { profile, related_links, previewImage, errors, isSaving } = this.state;
    const { defaultUserImage, handleEditButtonClick } = this.props;

    return (
      <div id='object-edit'>
        <div className='container'>
          <div className='row d-flex justify-content-center no-gutter'>
            <div id='object_unit' className='col-12 col-lg-10'>
              <form>
                <div className='row form-group'>
                  <div className='col-12 text-center mb-2'>
                    <label htmlFor='user-image'>
                      <span className='label-image-edit'>
                        <i className='fas fa-image' />
                        画像を編集
                      </span>
                      <img
                        src={previewImage.url || defaultUserImage}
                        alt='プロフィール画像'
                        className='img-thumbnail rounded-circle'
                      />
                      <input
                        name='image'
                        className={"d-none custom-file-input" + `${errors.image ? " is-invalid" : ""}`}
                        type='file'
                        id='user-image'
                        onChange={this.onPreviewImageChange}
                      />
                    </label>
                    <InvalidFeedback errors={errors.image} label='プロフィール画像' />
                  </div>
                </div>

                <div className='row form-group'>
                  <div className='col-12 col-md-6'>
                    <label className='col-form-label' htmlFor='user-profile-attributes-last-name'>姓</label>
                    <input
                      name='last_name'
                      className={`${errors.profile.last_name ? "form-control is-invalid" : "form-control"}`}
                      required='required'
                      type='text'
                      value={profile.last_name}
                      id='user-profile-attributes-last-name'
                      onChange={this.onProfileChange}
                    />
                    <InvalidFeedback errors={errors.profile.last_name} label='姓' />
                  </div>

                  <div className='col-12 col-md-6'>
                    <label className='col-form-label' htmlFor='user-profile-attributes-first-name'>名</label>
                    <input
                      name='first_name'
                      className={`${errors.profile.first_name ? "form-control is-invalid" : "form-control"}`}
                      required='required'
                      type='text'
                      value={profile.first_name}
                      id='user-profile-attributes-first-name'
                      onChange={this.onProfileChange}
                    />
                    <InvalidFeedback errors={errors.profile.first_name} label='名' />
                  </div>
                </div>

                <div className='row form-group'>
                  <div className='col-12 col-md-6'>
                    <label className='col-form-label' htmlFor='user-profile-attributes-job-title'>肩書き</label>
                  </div>
                  <div className='col-12 col-md-6'>
                    <input
                      name='job_title'
                      className={`${errors.profile.job_title ? "form-control is-invalid" : "form-control"}`}
                      placeholder='XXXX, inc. / CEO'
                      type='text'
                      value={profile.job_title || ""}
                      id='user-profile-attributes-job-title'
                      onChange={this.onProfileChange}
                    />
                    <InvalidFeedback errors={errors.profile.job_title} label='肩書き' />
                  </div>
                </div>

                <div className='row form-group'>
                  <div className='col-12 col-md-6'>
                    <label className='col-form-label' htmlFor='user-profile-link'>URL（ブログ・ポートフォリオサイトなど）</label>
                  </div>
                  <div className='col-12 col-md-6'>
                    <input
                      name='url'
                      className={`${errors.related_links[0].url ? "form-control is-invalid" : "form-control"}`}
                      placeholder='https://'
                      type='text'
                      value={related_links.length > 0 ? related_links[0].url : ""}
                      id='user-profile-link'
                      onChange={this.onRelatedLinksChange}
                    />
                    <InvalidFeedback errors={errors.related_links[0].url} label='URL' />
                  </div>
                </div>

                <div className='text-right mt-4'>
                  <input
                    type='button'
                    disabled={isSaving}
                    value='キャンセル'
                    className="btn btn-white-primary mr-2"
                    onClick={handleEditButtonClick}
                  />
                  <input
                    type='button'
                    disabled={isSaving}
                    value={isSaving ? "保存中..." : "保存"}
                    className="btn btn-primary"
                    onClick={this.handleFormSubmit}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ProfileForm.propTypes = {
  name: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  profile: PropTypes.shape({
    job_title: PropTypes.string,
    bio: PropTypes.string
  }).isRequired,
  related_links: PropTypes.arrayOf(PropTypes.object).isRequired,
  actions: PropTypes.objectOf(PropTypes.func).isRequired,
  defaultUserImage: PropTypes.string.isRequired,
  handleEditButtonClick: PropTypes.func.isRequired
};

export default ProfileForm;
